<template>
  <v-badge
    ref="badge"
    class="avatar"
    :value="showBadge"
    :class="isOnline ? 'avatar-online' : 'avatar-offline'"
    color=""
    left
    bottom
    overlap>

    <span slot="badge"></span>
    <v-avatar class="elevation-4" :size="size">
      <v-img
      v-if="id"
      class="elevation-2 def-profile-img"
      :src="avatarUrl + id"/>

      <v-img v-else class="elevation-2 def-profile-img"/>
    </v-avatar>
  </v-badge>
</template>

<script>
import sysConfig from '@/configs/sys';

export default {
  props: {
    id: {
      type: String
    },
    size: {
      type: Number,
      default: 48
    },
    isOnline: {}
  },

  data() {
    return {
      avatarUrl: sysConfig.matlsApiUrl + '/users/avatar/'
    };
  },

  computed: {
    showBadge() {
      return typeof this.isOnline === 'boolean';
    }
  },

  watch: {
    async showBadge(newValue, oldValue) {
      if (!newValue) {
        return;
      }
      await this.$nextTick();
      this.setBadgeStyle();
    }
  },

  mounted() {
    if (this.showBadge) {
      this.setBadgeStyle();
    }
  },

  methods: {
    setBadgeStyle() {
      let badgeSize = Math.floor(this.size/3);
      let offset = -Math.floor(badgeSize/3);
      let badge = this.$refs.badge.$el.querySelector('.v-badge__badge');
      badge.style.width = badgeSize + 'px';
      badge.style.height = badgeSize + 'px';
      badge.style.left = offset + 'px';
      badge.style.bottom = offset + 'px';
      badge.style.setProperty('border', '2px solid white', 'important');
    }
  }
};
</script>

<style lang="stylus" scoped>
.def-profile-img {
  background-color: white;
  background-image: url("../assets/img/student.svg");
  background-repeat: no-repeat;
  background-size: contain;
}

.avatar-online >>> .v-badge__badge {
  background-color: $success-color !important;
}

.avatar-offline >>> .v-badge__badge {
  background-color: rgb(163, 163, 163) !important;
}
</style>
